import React from 'react';
import { Box } from '@material-ui/core';
import { registerSmsCodeStep as registerLocales } from 'globals/locales/registration';

import FsSmsCodeForm from 'ui-elements/forms/FsSmsCodeForm';
import {
  FsCounterBox,
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './RegisterSmsCodeStep.style-elements';
import { RegisterStepProps } from '../Steps.types';

interface RegisterInitialStepProps extends RegisterStepProps {
  onGoNext?: () => void;
  onGoPrev?: () => void;
  phoneNumber?: string;
}

const RegisterSmsCodeStep: React.FC<RegisterInitialStepProps> = ({
  stepIndex,
  stepsLength,
  onGoNext,
  onGoPrev,
  phoneNumber,
}) => {
  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{registerLocales.hello}</FsHello>
        <FsCounterBox>
          <i>{stepIndex}</i>/{stepsLength}
        </FsCounterBox>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{registerLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>
        {registerLocales.subTitle} {phoneNumber}
      </FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsSmsCodeForm onGoNext={onGoNext} onGoPrev={onGoPrev} />
      </Box>
    </WrapperBox>
  );
};

export default RegisterSmsCodeStep;
